export const state = {
  boletaFactura: []
};

export const mutations = {
  add(state, boletaFactura) {
    state.boletaFactura = boletaFactura;
  }
};

export const getters = {
  boletaFactura: state => state.boletaFactura,
};

export const actions = {
  async addBoleta({ commit }, boletaFactura) {
    commit("add", boletaFactura);
  }
};
